// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_02712f2b3b--tabs--WuOr8"};